import { Controller } from '@hotwired/stimulus'
import noUiSlider from 'nouislider'

export default class extends Controller {
  static targets = ['input', 'slider']
  static values = { id: String, sliderOptions: Object }

  connect() {
    this.inputMin = parseInt(this.inputTarget.min)
    this.inputMax = parseInt(this.inputTarget.max)
    this.updatingFromInput = false

    const sliderDefaults = {
      behaviour: 'tap-drag',
      connect: 'lower',
      format: {
        to: value => parseInt(value),
        from: value => parseInt(value)
      },
      range: { min: 0, max: 100 },
      start: 0
    }

    // Merge defaults with user-provided sliderOptionsValue. Values in
    // sliderOptionsValue should overwrite defaults. We deep-merge the `range`
    // key to allow partially overriding min or max.
    const userSliderOptions = this.sliderOptionsValue || {}

    const mergedOptions = {
      ...sliderDefaults,
      ...userSliderOptions,
      range: { ...sliderDefaults.range, ...(userSliderOptions.range || {}) }
    }

    this.slider = noUiSlider.create(this.sliderTarget, mergedOptions)

    // runs when when a user stops sliding, when a slider value is changed by
    // 'tap', or on keyboard interaction
    this.slider.on('change', (values, handle, positions) => {
      this.inputTarget.value = Math.round(positions[0]).toLocaleString()
      this.inputTarget.dispatchEvent(new InputEvent('input'))
    })

    // runs when dragging slider, `set` method is called, slider is moved by
    // tapping it, or a handle is moved by arrow keys
    this.slider.on('update', (values, handle, positions) => {
      // Skip if we're updating from the input to prevent infinite loop
      if (this.updatingFromInput) return (this.updatingFromInput = false)

      this.inputTarget.value = Math.round(positions[0]).toLocaleString()
      this.inputTarget.dispatchEvent(new InputEvent('input'))
    })
  }

  formatInputValue(_event) {
    const sanitizedValue = this.#sanitizeInput(this.inputTarget.value)
    this.inputTarget.value = sanitizedValue.toLocaleString()
  }

  setSliderValue(_event) {
    const newValue = this.#sanitizeInput(this.inputTarget.value)

    // User typed in input, only update slider and prevent recursion
    this.updatingFromInput = true
    this.slider.setHandle(0, newValue)
  }

  #sanitizeInput(value) {
    // strip out any non-numeric characters and return value as an integer
    value = value.replace(/[.,]/g, '').replace(/^0+(?!\.|$)/, '')
    value = parseInt(value)
    if (isNaN(value)) value = 0
    if (value < this.inputMin) value = this.inputMin
    if (value > this.inputMax) value = this.inputMax
    return value
  }
}
